import { ConfigProvider } from 'antd';

const ThemeProvider = (props: any) => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#ff8300',
      },
    }}
  >
    {props.children}
  </ConfigProvider>
);

export default ThemeProvider;